// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `table th {
  font-weight: 800;
}
table th, table td {
  padding-left: 1rem;
}

.request-type {
  margin-bottom: 0;
}`, "",{"version":3,"sources":["webpack://./src/app/management/voice/hangup-request/index/index.component.scss"],"names":[],"mappings":"AACE;EACE,gBAAA;AAAJ;AAGE;EACE,kBAAA;AADJ;;AAKA;EACI,gBAAA;AAFJ","sourcesContent":["table {\r\n  th {\r\n    font-weight: 800\r\n  }\r\n\r\n  th, td {\r\n    padding-left: 1rem;\r\n  }\r\n}\r\n\r\n.request-type{\r\n    margin-bottom:0;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
